import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider, useLanguage } from "@/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import ProjectPage from "@/pages/ProjectPage";

const LANGS = ["da", "en", "sw"];

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 150);
      return () => clearTimeout(id);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function LangLayout() {
  const { lang } = useParams();
  const { setLang } = useLanguage();
  useEffect(() => {
    if (LANGS.includes(lang)) {
      setLang(lang);
      document.documentElement.lang = lang;
    }
  }, [lang, setLang]);
  if (!LANGS.includes(lang)) return <Navigate to="/da" replace />;
  return (
    <>
      <ScrollManager />
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <Outlet />
      <Footer />
      <Toaster position="top-center" richColors />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/da" replace />} />
            <Route path="/:lang" element={<LangLayout />}>
              <Route index element={<Home />} />
              <Route path="ventures/:slug" element={<ProjectPage />} />
              <Route path="*" element={<Navigate to="/da" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
